export default "__VITE_ASSET__25b741cc__"